// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f26c37bf","239":"d6ddd6e9","453":"831db367","732":"c577dd99"}[chunkId] + ".chunk.js";
};